export const invalidAccountNumber = function(value, field, model, messages=null) {
    if (value && !value.match(/^[0-9]{6,11}$/)) {
        if (!messages) {
            return ["Account number must be between 6 and 11 digits."];
        } else {
            return [messages.invalidAccountNumber];
        }
    }
    return [];
}


export const invalidSortCode = function(value, field, model, messages=null) {
    if (value && !value.match(/^[0-9]{6}$/)) {
        if (!messages) {
            return ["Sort code must be 6 digits. Please do not include hyphens."];
        } else {
            return [messages.invalidSortCode];
        }
    }
    return [];
}
